module.exports = __webpack_public_path__ + "img/fisher-icon-copy-blue.88726db0.svg";